class VariantSelects extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.addEventListener('change', () => this.onVariantChange());
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.updateButtons(false);
  }
  get scope() { return this.closest('#content_quickview, .product-template__container, [data-section-type="product"]') || this.closest('.shopify-section') || document; }
  get peers() { return [...this.scope.querySelectorAll('variant-radios, variant-selects, variant-selects-stick')].filter(picker => picker.dataset.section === this.dataset.section); }
  get forms() { return [...this.scope.querySelectorAll('form.product-form')].filter(form => form.dataset.section === this.dataset.section); }
  get strings() { return window.variantStrings || {}; }
  updateOptions() { this.options = [...this.querySelectorAll('select')].map(select => select.value); }
  getVariantData() {
    if (!this.variantData) this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateMasterId() { this.currentVariant = this.getVariantData().find(variant => variant.options.every((value, index) => value === this.options[index])); }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.scope.lcVariantRequest?.abort();
    this.scope.lcVariantVersion = (this.scope.lcVariantVersion || 0) + 1;
    this.syncPickers();
    this.updateVariantInput();
    this.setError('');
    this.updateButtons(Boolean(this.currentVariant));
    this.updatePickupAvailability();
    if (!this.currentVariant) return;
    this.updateMedia();
    this.updateURL();
    this.renderProductInfo();
  }
  syncPickers() {
    this.peers.forEach(picker => {
      const groups = [...picker.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown')];
      groups.forEach((group, index) => {
        const value = this.options[index];
        group.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === value; });
        const select = group.querySelector('select');
        if (select) select.value = value;
        const label = group.querySelector('.variant_current');
        if (label) label.textContent = value || '';
      });
      picker.options = [...this.options];
      picker.currentVariant = this.currentVariant;
      picker.updateVariantStatuses();
    });
  }
  updateVariantStatuses() {
    const variants = this.getVariantData();
    const groups = [...this.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown')];
    groups.forEach((group, index) => {
      group.querySelectorAll('input[type="radio"], option').forEach(input => {
        const available = variants.some(variant => variant.available && variant.options[index] === input.value && variant.options.slice(0, index).every((value, previous) => value === this.options[previous]));
        input.classList.toggle('disabled', !available);
        input.dataset.available = String(available);
        if (input.tagName === 'OPTION') input.textContent = available ? input.value : (this.strings.unavailable_with_option || '[value] — unavailable').replace('[value]', input.value);
        else input.setAttribute('aria-describedby', `VariantStatus-${this.dataset.section}`);
      });
    });
  }
  updateVariantInput() {
    this.forms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant ? this.currentVariant.id : '';
      input.disabled = !this.currentVariant;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  get metadata() {
    if (!this.currentVariant) return null;
    return [...this.scope.querySelectorAll('[data-variant-metadata] option, #productSelect option')].find(option => option.value === String(this.currentVariant.id));
  }
  updateButtons(loading) {
    const variant = this.currentVariant;
    const available = Boolean(variant?.available);
    const metadata = this.metadata;
    const preorder = metadata?.dataset.policy === 'continue' && metadata?.dataset.tracked === 'true' && Number(metadata?.dataset.qty) < 1;
    this.forms.forEach(form => {
      const button = form.querySelector('[name="add"]');
      if (!button) return;
      const text = button.querySelector('[data-add-to-cart-text], #AddToCartText');
      button.disabled = loading || !available;
      button.setAttribute('aria-disabled', String(button.disabled));
      button.setAttribute('aria-busy', String(loading));
      if (text) text.textContent = !variant ? this.strings.unavailable : !available ? this.strings.soldOut : preorder ? this.strings.preorder : this.strings.addTobag || this.strings.addToCart;
      const parent = button.closest('.product-form__item--submit');
      parent?.classList.remove('soldout');
      parent?.removeAttribute('data-toggle');
      parent?.removeAttribute('data-target');
      const notify = form.querySelector('[data-lc-notify]');
      if (notify) notify.hidden = !variant || available;
      const checkout = form.querySelector('.product-form__item--checkout');
      if (checkout) {
        checkout.hidden = !available;
        checkout.inert = loading || !available;
        checkout.toggleAttribute('disabled', loading || !available);
        checkout.setAttribute('aria-busy', String(loading));
      }
      const quantity = form.querySelector('[name="quantity"]');
      if (quantity) {
        if (metadata?.dataset.tracked === 'true' && metadata.dataset.policy !== 'continue' && Number(metadata.dataset.qty) > 0) {
          quantity.max = metadata.dataset.qty;
          if (Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
        } else quantity.removeAttribute('max');
      }
    });
    this.scope.querySelectorAll('[data-variant-status]').forEach(status => { status.textContent = !variant ? this.strings.unavailable : !available ? this.strings.soldOut : ''; });
    const sku = this.scope.querySelector('[data-variant-sku], #variantSku');
    if (sku) sku.textContent = variant?.sku || '';
  }
  updateURL() {
    if (this.dataset.updateUrl === 'false' || this.closest('#content_quickview') || !document.body.classList.contains('template-product')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', url.toString());
  }
  updateMedia() {
    if (!this.currentVariant?.featured_media) return;
    const media = this.scope.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
    if (!media) return;
    this.scope.querySelectorAll('.proFeaturedImage .item').forEach(item => item.classList.toggle('act', item === media));
    const gallery = media.closest('.proFeaturedImage');
    if (gallery && window.jQuery?.fn.slick && window.jQuery(gallery).hasClass('slick-initialized')) {
      const slide = media.closest('[data-slick-index]');
      if (slide) window.jQuery(gallery).slick('slickGoTo', Number(slide.dataset.slickIndex));
    }
  }
  updatePickupAvailability() {
    const pickup = this.scope.querySelector('pickup-availability');
    if (!pickup) return;
    if (this.currentVariant?.available) pickup.fetchAvailability?.(this.currentVariant.id);
    else { pickup.removeAttribute('available'); pickup.innerHTML = ''; }
  }
  setError(message) {
    this.forms.forEach(form => {
      const error = form.querySelector('.product-form__item-error');
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
      error.classList.toggle('hidden', !message);
    });
  }
  async renderProductInfo() {
    const root = this.scope;
    const version = root.lcVariantVersion;
    const controller = new AbortController();
    root.lcVariantRequest = controller;
    const url = new URL(this.dataset.url, window.location.origin);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.searchParams.set('variant', this.currentVariant.id);
    url.searchParams.set('section_id', this.dataset.originalSection || this.dataset.section);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Product response failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted || version !== root.lcVariantVersion || !this.isConnected) return;
      let updated = false;
      ['ProductPrice-', 'ProductPriceStick-'].forEach(prefix => {
        const destination = root.querySelector(`[id="${prefix}${this.dataset.section}"]`);
        const source = html.getElementById(`${prefix}${this.dataset.originalSection || this.dataset.section}`);
        if (source && destination) { destination.innerHTML = source.innerHTML; updated = true; }
      });
      if (!updated) throw new Error('Product price missing');
      if (window.Currency?.convertAll && typeof shopCurrency !== 'undefined') {
        const selected = document.querySelector('[data-currency-picker] span.selected, [data-currency-picker] span.selected');
        window.Currency.convertAll(shopCurrency, selected?.dataset.currency || shopCurrency);
      }
      this.updateButtons(false);
    } catch (error) {
      if (error.name === 'AbortError' || version !== root.lcVariantVersion) return;
      this.updateButtons(true);
      this.forms.forEach(form => form.querySelector('[name="add"]')?.setAttribute('aria-busy', 'false'));
      this.setError(this.strings.updateError || 'We could not update this option. Select it again or refresh the page.');
    }
  }
}
class VariantRadios extends VariantSelects {
  updateOptions() { this.options = [...this.querySelectorAll('fieldset')].map(fieldset => fieldset.querySelector('input:checked')?.value); }
}
class VariantSelectsStick extends VariantSelects {}
if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);
if (!customElements.get('variant-radios')) customElements.define('variant-radios', VariantRadios);
if (!customElements.get('variant-selects-stick')) customElements.define('variant-selects-stick', VariantSelectsStick);
document.addEventListener('submit', event => {
  const form = event.target.closest('form[data-lc-product-form]');
  if (!form) return;
  const id = form.querySelector('input[name="id"]');
  const button = form.querySelector('[name="add"]');
  if (!id?.value || id.disabled || button?.disabled) { event.preventDefault(); return; }
  if (event.submitter && event.submitter !== button) return;
  if (window.jQuery && button) { event.preventDefault(); button.click(); }
});
